<template>
    <span data-comp="Countdown" class="d-inline-flex text-mono">
        <span data-part="digit">{{ hours | two_digits }}</span>
        <span data-part="separator">:</span>
        <span data-part="digit">{{ minutes | two_digits }}</span>
        <span data-part="separator">:</span>
        <span data-part="digit">{{ seconds | two_digits }}</span>
    </span>
</template>
<script>
    import moment from 'moment';
    import 'moment-timezone';
    import Utils from '@/services/utils.js';

    export default {

        methods: {
            updateTime: function(){
                if(moment().isBefore(moment(this.transformedDate))){
                    this.now = Math.trunc((moment()) / 1000);
                    this.Idate = Math.trunc((moment(this.transformedDate)) / 1000);
                }
                else{
                    this.now = Math.trunc((moment(this.transformedDate)) / 1000);
                    this.Idate = Math.trunc((moment(this.transformedDate)) / 1000);
                    this.$emit('expired',this.item);
                }
            }
        },

        mounted() {
            this.interval = window.setInterval(() => {
                this.updateTime();

            },1000);

            this.updateTime();
        },

        props : {
            date : {
                type: [String,Object],

            },
            item: {
                type: Object,
            }
        },

        data() {
            return {
                interval: null,
                now: Math.trunc((moment()) / 1000),
                Idate : Math.trunc((moment(this.transformedDate)) / 1000),
            }
        },

        computed: {
            seconds() {
                return (this.Idate - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.Idate - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.Idate - this.now) / 60 / 60);
            },
            transformedDate: function(){
                if(typeof this.date === 'object'){
                    return Utils.momentLocalised(this.date).format('YYYY-MM-DD HH:mm:ss');
                }
                else{
                    return this.date;
                }
            }


        }
    }

</script>

